module.exports = "module.exports = __webpack_public_path__ + \"static/media/detail.c6d76ab4.md\";"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/components/Projects/_projects/bcit-prog-tracker/detail.md
// module id = 266
// module chunks = 0